import React, { useEffect, useState } from 'react';
import { Grid, Typography, Autocomplete, TextField, Button, InputAdornment } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
  callSubmitEventAction,
  getAllSupervisiorByDiscipline,
  resetSubmissionEventAction,
} from 'src/redux/actions/documentationAction';
import loader from 'src/components/LoaderImg/loader.gif';

type Props = {
  close: any;
  activeTab: string;
  selectedDocument: any;
  role: string;
  source?: 'FROM_DSN' | '';
  DSNId?: string;
};

const SelectSuperVisor = (props: Props) => {
  const { close, activeTab, selectedDocument, role, source = '', DSNId } = props;
  const getAllTherapistsResponse = useSelector((state: any) => state.getAllSupervisorsReducer);
  const [searchData, setSearchData] = useState('');
  const [searchTimeout, setSearchTimeout] = useState<NodeJS.Timeout | null>(null);
  const [selectedData, setSelectedData] = useState<any>(null);
  const checkAddSupervisorResponse = useSelector((state: any) => state.callSubmitEventReducer);

  const dispatch = useDispatch();
  const [dsnUuid, setDsnUuid] = useState<string>('');
  useEffect(() => {
    if(!DSNId) return;
    setDsnUuid(DSNId);
  }, [DSNId]);

  const handleChangeSupervisor = (e: any, value: any) => {
    setSelectedData(value);
  };

  const handleSearchInputChange = (e: any) => {
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    const timeout = setTimeout(() => {
      setSearchData(e.target.value);
    }, 1000);

    setSearchTimeout(timeout);
  };

  useEffect(() => {
    dispatch(
      getAllSupervisiorByDiscipline({
        discipline: activeTab,
        documentType: 
          source === 'FROM_DSN'
            ? 'DAILY_SOAP_NOTE' :
            selectedDocument?.formType === 'DAILY_SOAP_NOTE_REFORM' ? 'DAILY_SOAP_NOTE' :
              selectedDocument?.documentType.replaceAll(' ', '_').toUpperCase(),
      })
    );
  }, []);

  const handleSelectSupervisor = () => {
    if (source === 'FROM_DSN') {
      dispatch(
        callSubmitEventAction(
          {
            supervisorId: selectedData?.uuid,
            uuid: dsnUuid || '',
            documentType: 'DAILY_SOAP_NOTE',
          },
          { isSuper: true }
        )
      );
    } else {
      dispatch(
        callSubmitEventAction(
          {
            providerId: selectedDocument.providerId,
            formId: selectedDocument.formId,
            submissionId: selectedDocument.submissionId,
            episodeOfCareId: selectedDocument.episodeOfCareId,
            type: activeTab,
            isForSupervisor: true,
            supervisorId: selectedData?.uuid,
            uuid: selectedDocument.uuid,
            documentType: selectedDocument?.formType,
          },
          { isSuper: true }
        )
      );
    }
  };

  useEffect(() => {
    if (!checkAddSupervisorResponse.isEventCalled && checkAddSupervisorResponse.response === null)
      return;
    dispatch(resetSubmissionEventAction());
    close();
  }, [checkAddSupervisorResponse]);

  return (
    <Grid sx={{ background: '#FFF', width: '725px', height: '287px' }}>
      <Grid sx={{ padding: '24px' }}>
        <Typography variant="h6">Select {`${role === 'Physician' ? 'physician' : 'supervisor'}`} to request their signature</Typography>
        {
          role === 'Physician' ? null : <Typography
            variant="body2"
            mt={1}
          >
            {activeTab}
          </Typography>
        }  
      </Grid>

      <Grid sx={{ padding: '24px' }}>
        <Autocomplete
          getOptionLabel={(option: any) => option.name}
          fullWidth
          options={getAllTherapistsResponse.response?.data}
          onChange={(e, value) => handleChangeSupervisor(e, value)}
          onInputChange={(e: any) => handleSearchInputChange(e)}
          // filterOptions={filterOptions}
          value={selectedData}
          disabled={
            getAllTherapistsResponse?.loading ||
            getAllTherapistsResponse.response?.data?.length === 0
          }
          renderInput={(params): JSX.Element => (
            <TextField
              {...params}
              fullWidth
              label={
                getAllTherapistsResponse.response?.data?.length === 0
                  ? 'No Records Found'
                  : `Select ${role === 'Physician' ? 'physician' : 'supervisor'}`
              }
              name="supervisor"
            />
          )}
        />
      </Grid>

      <Grid
        container
        justifyContent={'right'}
        sx={{ paddingRight: '24px' }}
      >
        <Button
          sx={{ marginRight: '8px' }}
          onClick={close}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSelectSupervisor}
          disabled={!selectedData}
        >
          {getAllTherapistsResponse.loading ? (
            <img
              src={loader}
              style={{ height: 30 }}
              alt=''
            />
          ) : (
            'Confirm'
          )}
        </Button>
      </Grid>
    </Grid>
  );
};

export default SelectSuperVisor;
